import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=8ed637b2&scoped=true&"
import script from "./Locales.vue?vue&type=script&lang=js&"
export * from "./Locales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed637b2",
  null
  
)

export default component.exports